import { render, staticRenderFns } from "./ReviewerTable.vue?vue&type=template&id=ac31734a"
import script from "./ReviewerTable.vue?vue&type=script&lang=js"
export * from "./ReviewerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports